import React, { useCallback, useRef, useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as a from 'actions/livefeedapi';
import { useDispatch, useSelector } from 'react-redux'
import config from "config";

import EditUserForm from './EditUserForm';
import Modal from "components/common/modal";
import Select from 'react-select';
import { setEditorDefaultState } from 'actions/livefeed';
import ReactTooltip from "react-tooltip";
import ReactTable from "react-table";
import moment from 'moment';


const LivefeedTableList = (props) => {
    const deleteLivefeedModal = useRef(null)
    const editUserForm = useRef(null)
    const addLivefeedModal = useRef(null)
    const [componentState, setComponentState] = useState({})

    const dispatch = useDispatch();
    const { urls, templates } = useSelector(state => state.livefeedAPIReducer)
    const user = useSelector(state => state.myAccountReducer.user)
    const isAdmin = user.role === config.roles[0].rolecode
    useEffect(() => {
        ReactTooltip.rebuild() // componentDidUpdate()
    })

    function makeHandlerDelete(index) {
        return () => {
            const url = urls[index];
            setComponentState({
                ...componentState,
                deletedLivefeedKey: url.key,
                deletedLivefeedName: url.name
            })
            deleteLivefeedModal.current.open();
        }
    }
    const deleteLivefeed = useCallback((key, fClose) => {
        /*
            Format :
                key : "2e6010cf-1766-46bc-bbad-9d3fd638df1c"
        */
        dispatch(a.deleteLivefeed(key, fClose));
    }, [dispatch])

    const navigateToEditor = useCallback((mode, index) => {
        switch (mode) {
            case "createFromTemplate": {
                dispatch(setEditorDefaultState());
                const { label: key, data } = componentState.template
                let passedData = data
                passedData.livefeedName = componentState.template.label
                props.router.push({
                    pathname: '/livefeed/editor',
                    state: {
                        mode: "createLivefeed",
                        key: key,
                        passedData: passedData,
                        templateList: templates
                    }
                })
            }
                break;
            case "createBlank": {
                dispatch(setEditorDefaultState());
                props.router.push({
                    pathname: '/livefeed/editor'
                })
            }
                break;
            case "edit": {
                dispatch(setEditorDefaultState());
                var livefeed = urls[index];
                const { key, subscribers } = livefeed;
                let passedData = livefeed.data;
                passedData.livefeedName = livefeed.name
                props.router.push({
                    pathname: '/livefeed/editor',
                    state: {
                        mode: "editLivefeed",
                        key: key,
                        passedData: passedData,
                        subscribers: subscribers,
                        templateList: templates
                    }
                });
            }
                break;
        }
    }, [componentState.template, dispatch, props.router, templates, urls])

    function handleTemplateSelect(key, option) {
        // Handle changes for Select components
        if (option.value === "add") {
            navigateToEditor("createBlank")
        } else {
            setComponentState({
                ...componentState,
                [key]: option
            })

        }
    }
    function selectCreateOptions() {
        var ar = templates.map((x) => {
            let a = {
                value: x.id,
                label: x.name,
                data: x.data
            }
            return a;
        });

        ar.push({
            value: "add",
            label: "Add without template",
            data: "",
            className: "add-template"
        });

        return ar;
    }
    const handlePreviewLivefeed = useCallback((index) => {
        dispatch(a.previewLivefeed(urls[index]))
    }, [dispatch, urls])

    //------------------------------------------- CRUD btns fn Render -----------------------------------
    function renderCellBtn(child) {
        return (
            <div className="livefeed-child livefeed-child_icons">
                {child}
            </div >
        )
    }
    const editDeleteBtns = (index) =>
        <Fragment>
            {renderCellBtn(
                <i className="material-icons users--icons" data-tip="Edit users"
                    onClick={() => editUserForm.current.openEditUserModal(index)}>group</i>
            )}
            {renderCellBtn(
                <i className="material-icons edit--icons" data-tip="Edit livefeed"
                    onClick={() => { navigateToEditor("edit", index) }}>edit</i>
            )}
            {renderCellBtn(
                <i className="material-icons delete--icons" data-tip="Delete"
                    onClick={makeHandlerDelete(index)}>clear</i>
            )}
        </Fragment>
    //------------------------------------------- Collumns for table -----------------------------------
    const columns = [
        {
            expander: true,
            Expander: ({ isExpanded }) =>
                <i data-tip="Click to see floorplans on this livefeed" className={` expand-btn ${isExpanded ? 'expand-btn_active ' : ''} material-icons`}>
                    {isExpanded ? 'remove_circle_outline' : 'add_circle_outline'}
                </i>
            ,
            style: {
                cursor: "pointer", fontSize: 25, padding: "0", justifyContent: "center",
                alignItems: "center", display: "flex", userSelect: "none"
            }
        },
        {
            Header: "Name", accessor: "name",
            Filter: ({ filter, onChange }) => (
                <input type='text' placeholder="Search livefeed"
                    value={filter ? filter.value : ''}
                    onChange={event => onChange(event.target.value)}
                />
            ),
            Cell: ({ value, original }) =>
                <div data-tip="Go to livefeed" className="livefeed-child livefeed-child_name">
                    <a href={config.livefeed.root + "/#/url?k=" + original.key}
                        className="ellipsis" target="_blank" rel="noopener noreferrer">
                        {value}
                    </a >
                </div>
        },
        {
            width: 180, Header: "Creator", accessor: "owner",
            Cell: ({ value }) =>
                <div className="livefeed-child">
                    <span className="ellipsis">{value} </span>
                </div>
        },
        {
            id: "date", width: 180, Header: "Date",
            accessor: ({ data }) => data.timestamp,
            Cell: ({ value }) =>
                <div className="livefeed-child">
                    <span className="ellipsis">
                        {moment(value).local().format("DD-MM-YYYY HH:mm:ss")}
                    </span>
                </div>
        },
        {
            Header: "Actions", width: 200, style: { padding: 0, height: 44 }, filterable: false, sortable: false, resizable: false,
            Cell: ({ index }) =>
                <div className="livefeed-crud">
                    {renderCellBtn(
                        <i className="material-icons preview--icons" data-tip="Preview"
                            onClick={() => handlePreviewLivefeed(index)}>&#xe895;</i>
                    )}
                    {isAdmin ?
                        <Fragment>
                            {editDeleteBtns(index)}
                        </Fragment>
                        :
                        <span className="livefeed-child_disabled" data-tip='Only Admins can edit and delete'>
                            {editDeleteBtns(index)}
                        </span>
                    }
                </div>
        }
    ]
    function addLivefeed() {
        if (isAdmin) { // only admin can add
            (templates.length > 0 ?
                addLivefeedModal.current.open() :
                navigateToEditor("createBlank"))
        }
    }
    return (
        <Fragment>
            <h3 className="live-feed-title">Livefeeds</h3>
            <div data-tip={`${!isAdmin ? 'Only Admins can add' : ''}`}
                className={`button btn--green add-livefeed-btn ${!isAdmin ? 'add-livefeed-btn_disabled' : ''}`}
                onClick={() => addLivefeed()}>
                <span className="font-icon icon-addicon" />
                Add Livefeed
             </div>
            <div className="all-feed-container">
                {urls.length <= 0 ?
                    <div>No livefeed has been created yet</div>
                    :
                    <span >
                        <ReactTooltip place="top" type="dark" effect="solid" />
                        <ReactTable
                            data={urls} columns={columns}
                            style={{
                                height: "400px" // This will force the table body to overflow and scroll, since there is not enough room
                            }}
                            defaultSorted={[
                                {
                                    id: "date",
                                    desc: true
                                }
                            ]}
                            filterable
                            defaultPageSize={10}
                            freezeWhenExpanded={true}
                            SubComponent={({ original: { name, locations } }) =>
                                <div className={"location-list"}>
                                    {locations.length > 1 ?
                                        `These locations are displayed in ${name}` :
                                        `This location is displayed in ${name}`}
                                    <ul>
                                        {locations.map((location, index) => {
                                            return (
                                                <li key={index}>
                                                    {location.locationName}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            }
                            className="-highlight livefeed-list-table"
                        />
                    </span>
                }
            </div>

            <EditUserForm
                ref={editUserForm}
            />
            <Modal
                ref={addLivefeedModal}
                clickButton={() => navigateToEditor("createFromTemplate")}
                header="Add Livefeed"
                buttonText="Continue"
                buttonClass="btn-success"
                buttonHide={true}
                entry={null}
            >
                <div className="add-feed-modal">
                    <div>
                        <p>Please select a template for your new Livefeed or&nbsp;
                            <a onClick={() => navigateToEditor("createBlank")}
                                className="add-template live-feed-button">Add without template</a>
                        </p>

                        <Select
                            autoFocus={true}
                            openOnFocus={true}
                            openOnClick={true}
                            closeOnSelect={true}
                            clearable={false}
                            onChange={(option) => { handleTemplateSelect("template", option) }}
                            options={selectCreateOptions()}
                            placeholder="Select template for livefeed"
                            value={componentState.template}
                        />
                    </div>
                    <div style={{ height: "0px" }}></div>
                </div>
            </Modal>
            <Modal
                ref={deleteLivefeedModal}
                clickButton={() => deleteLivefeed(componentState.deletedLivefeedKey, deleteLivefeedModal.current.close())}
                header="Delete livefeed"
                buttonText="Delete"
                buttonClass="btn-danger"
                entry={null}
            >
                <p><b>All invited users will no longer have access to this livefeed view.</b><br>
                </br>Are you sure you want to delete livefeed
                    <b> {componentState.deletedLivefeedName}</b> ?</p>
            </Modal>
        </Fragment>
    );
}
LivefeedTableList.propTypes = {
    router: PropTypes.any.isRequired
}
export default LivefeedTableList


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/SwitchTab/LivefeedTableList/index.jsx